import React from "react";
import { Modal } from "react-bootstrap";

interface AppDialogProps {
    show: boolean;
    onHide: () => void;
    title?: React.ReactNode;
    children: React.ReactNode;
    footer?: React.ReactNode;
    size?: "sm" | "md" | "lg" | "xl"; // Keep md in our interface
    fullScreen?: boolean;
    backdrop?: boolean | "static";
    closeButton?: boolean;
}

const AppDialog: React.FC<AppDialogProps> = ({
    show,
    onHide,
    title,
    children,
    footer,
    size = "xl",
    fullScreen = false,
    backdrop = "static",
    closeButton = true,
}) => {
    // Handle "md" size by not passing any size prop (Bootstrap default)
    const modalSize = size === "md" ? undefined : size;

    return (
        <Modal
            show={show}
            onHide={onHide}
            size={modalSize} // Use undefined for "md" size
            backdrop={backdrop}
            centered
            dialogClassName={fullScreen ? "fullscreen-modal-dialog" : undefined}
            contentClassName="border-0"
            keyboard={false}
        >
            {title && (
                <Modal.Header
                    className="bg-primary text-white"
                    closeButton={closeButton}
                    closeVariant="white"
                >
                    <Modal.Title className="text-white">{title}</Modal.Title>
                </Modal.Header>
            )}
            <Modal.Body style={{ padding: 0 }}>{children}</Modal.Body>
            {footer && (
                <Modal.Footer className="d-flex w-100">{footer}</Modal.Footer>
            )}
            <style jsx global>{`
                .fullscreen-modal-dialog {
                    max-width: 100vw;
                    width: 100vw;
                }
                @media (min-width: 1200px) {
                    .fullscreen-modal-dialog {
                        max-width: 1100px;
                        width: 95vw;
                    }
                }
            `}</style>
        </Modal>
    );
};

export default AppDialog;
